import {ReactComponent as CrownIcon} from '../../../assets/images/icon-crown.svg'
import useDialog from "../../../hooks/useDialog";
import SubscriptionPlanDialog from "../../SubscriptionPlan/SubscriptionPlanDialog";
import AivatarButton from "../../buttons/AivatarButton";
import {useTranslation} from "react-i18next";
import {trackUpgradeCTA} from "../../../analytics/tracking";

export default function NavUpgradeButton() {
    const {t} = useTranslation('dashboard')
    const dialog = useDialog()

    const handleClicked = () => {
        trackUpgradeCTA('dashboard_nav')
        dialog.open(<SubscriptionPlanDialog expanded/>)
    }

    return (
        <button
            type="button"
            onClick={handleClicked}
            className="w-56 h-8 px-4 py-3 bg-orange-100 rounded-lg inline-flex justify-center items-center gap-[5px] hover:bg-orange-200 transition-all"
        >
      <span className="text-center text-amber-500 text-sm font-bold font-['Pretendard']">
          {t('업그레이드')}
      </span>
            <CrownIcon className="w-4 h-3.5 fill-amber-500"/>
        </button>
    )
}
